import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import "../assets/css/boxButton.css";
import { useLocation } from "react-router-dom";

const BoxButton = ({ open, onRigenera, onApprova, onRiavvia, amlStatus }) => {
  const location = useLocation();
  const isDetailRoute = /^\/aml\/\d+$/.test(location.pathname);

  if (isDetailRoute && amlStatus !== "submitted" && amlStatus !== "expired")
    return null;

  return (
    <Grid
      container
      className="bg-blue-dark"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        py: "15px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        container
        item
        xs={11.3}
        alignItems="center"
        sx={{ flexWrap: "nowrap" }}
      >
        {!isDetailRoute && (
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              className="button-bg-purple"
              onClick={() => open(true)}
              sx={{
                width: { xs: "140px", sm: "160px", md: "180px" },
                height: "40px",
                border: "none",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Box className="icon-create-aml-button" />
              <Typography
                className="color-light"
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  fontWeight: 500,
                  lineHeight: 1,
                }}
              >
                Crea modulo
              </Typography>
            </Button>
          </Grid>
        )}

        {isDetailRoute && amlStatus === "submitted" && (
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button
              variant="outlined"
              className="button-bg-light"
              onClick={onRigenera}
              sx={{
                width: { xs: "140px", sm: "160px", md: "180px" },
                height: "40px",
                border: "none",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Box className="icon-reset-link-aml-button" />
              <Typography
                className="color-light"
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  fontWeight: 500,
                  lineHeight: 1,
                }}
              >
                Rigetta
              </Typography>
            </Button>
            <Button
              variant="contained"
              className="button-bg-purple"
              onClick={onApprova}
              sx={{
                width: { xs: "140px", sm: "160px", md: "180px" },
                height: "40px",
                border: "none",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Box className="icon-approved-aml-button" />
              <Typography
                className="color-light"
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  fontWeight: 500,
                  lineHeight: 1,
                }}
              >
                Approva
              </Typography>
            </Button>
          </Grid>
        )}

        {isDetailRoute && amlStatus === "expired" && (
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              className="button-bg-purple"
              onClick={onRiavvia}
              sx={{
                width: { xs: "140px", sm: "160px", md: "180px" },
                height: "40px",
                border: "none",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Box className="icon-restar-aml-expired" />
              <Typography
                className="color-light"
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  fontWeight: 500,
                  lineHeight: 1,
                }}
              >
                Rinnova
              </Typography>
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default BoxButton;
